import { revokeRefreshToken } from 'src/backend/auth';
import { setSession } from 'src/redux/slices/auth';
import { PATH_AUTH, PATH_DASHBOARD } from 'src/routes/paths';
import {
  clearAdminImpersonation,
  isHandoffImpersonation,
} from 'src/utils/adminImpersonation';

/**
 * Leaves an admin impersonation: back to the super admin's own session on
 * the Careit dashboard, or, for a white-label handoff (no admin session on
 * that origin), ends the session and closes the tab.
 */
export default async function endAdminImpersonation(impersonation) {
  if (isHandoffImpersonation(impersonation)) {
    const refreshToken = localStorage.getItem('refresh-token');
    if (refreshToken) {
      await revokeRefreshToken(refreshToken).catch(() => {});
    }
    clearAdminImpersonation();
    setSession(null, null);

    window.close();
    if (!window.closed) {
      const { exitUrl } = impersonation;
      window.location.replace(
        /^https?:\/\//i.test(exitUrl || '') ? exitUrl : PATH_AUTH.login
      );
    }
    return;
  }

  const { returnToken, returnRefreshToken, returnPath } = impersonation || {};
  clearAdminImpersonation();
  if (returnToken && returnRefreshToken) {
    setSession(returnToken, returnRefreshToken);
  }
  // Replace so the impersonated page is dropped from browser history.
  window.location.replace(returnPath || PATH_DASHBOARD.admin.overview);
}
